import { ActionType, getType } from 'typesafe-actions';

import * as currentOrder from '../../actionCreators/currentOrder';

const initialState = null;

export default function (
  state: string | null = null,
  action: ActionType<typeof currentOrder>,
): string | null {
  switch (action.type) {
    case getType(currentOrder.resetOrder): {
      return initialState;
    }
    case getType(currentOrder.setTable): {
      const { value } = action.payload;
      return value || null;
    }
    case getType(currentOrder.adjustTable): {
      const { value } = action.payload;

      switch (value) {
        case 'clear': {
          return initialState;
        }
        case 'delete': {
          return (state || '').slice(0, -1);
        }
        default:
          return `${state || ''}${value}`.trimLeft();
      }
    }
    default:
      return state;
  }
}
